module.exports = __webpack_public_path__ + "media/images/banner/coupons/coupon02-en-d02e0494c81406b2b00af1755a535bf3.png";